<!-- Product Accordion All Labels Except Supplement ESL -->
<lx-quote-product-label
  [quoteKey]="quoteKey"
  [hasProductLabelUnits]="product?.units > 1 && product?.classification === productTypes?.SUPPLEMENT"
  [productUnits]="product?.units | lxLocalizeAndPluralizePeriod"
  [productName]="product?.classification !== productTypes?.TRANSFER ? product?.name : transferMessage"
  [hasProductInfo]="availableOptOutProduct"
  [isProductEditable]="isQuoteSlotExpanded && isProductEditable"
  (infoButtonClicked)="infoButtonClicked.emit()"
  (editButtonClicked)="editButtonClicked.emit()"
  (removeButtonClicked)="removeButtonClicked.emit()"
></lx-quote-product-label>

<!-- Product Accordion Descriptions Course ESL (Array) -->
<lx-quote-product-description *ngIf="!!product?.descriptions" [isArray]="true" [productDescription]="product?.descriptions"></lx-quote-product-description>

<!-- Product Accordion Descriptions Transfers (Not Array) -->
<lx-quote-product-description *ngIf="product?.classification === productTypes?.TRANSFER" [productDescription]="[product?.name]"></lx-quote-product-description>

<!-- Product Accordion All Descriptions (Date Units) except Insurance (Not Array) -->
<lx-quote-product-description
  *ngIf="!!product?.units && !!product?.startDate"
  [productDescription]="!availableOptOutProduct ? [product?.units | lxLocalizeAndPluralizePeriod] : []"
></lx-quote-product-description>

<!-- Product Accordion Descriptions (Date Units) Insurance (Not Array) -->
<lx-quote-product-description
  *ngIf="(product?.classification === productTypes?.INSURANCE || product?.classification === productTypes?.TUITION) && product?.units && !product?.startDate"
  [productDescription]="[product?.units | lxLocalizeAndPluralizePeriod]"
></lx-quote-product-description>

<!-- Product Accordion Descriptions (Date Units) Premium Activities (Not Array) -->
<lx-quote-product-description
  *ngIf="product?.classification === productTypes?.PREMIUM_ACTIVITIES"
  [productDescription]="[product?.units | lxLocalizeAndPluralizePeriod]"
></lx-quote-product-description>

<!-- Product Accordion Premium Activities Dates (Array) -->
<lx-quote-product-date
  *ngIf="!!product?.selectedWeeks"
  [isArray]="true"
  [dateFormat]="dateFormat"
  [productSelectedWeeks]="product?.selectedWeeks"
></lx-quote-product-date>

<!-- Product Accordion All Date Ranges (not array) -->
<lx-quote-product-date
  *ngIf="product?.endDate && !(currentCourses?.length > 1 && isAccommodationMandatory && product?.classification === productTypes?.ACCOMMODATION)"
  [dateFormat]="dateFormat"
  [productSelectedWeeks]="!availableOptOutProduct ? selectedWeeks : []"
></lx-quote-product-date>

<!-- Product Accordion Descriptions Disclaimer ESL (Not Array) -->
<lx-quote-product-description
  *ngIf="product?.seasonVariation && product?.classification === productTypes?.SUPPLEMENT"
  [hasDisclaimer]="true"
  [productDescription]="[disclaimerMessage]"
></lx-quote-product-description>

<!-- Product Accordion Descriptions Vacations (Not Array) -->
<lx-quote-product-description
  *ngIf="weekLongVacation?.length > 0"
  [hasVacations]="true"
  [productDescription]="[weekLongVacation | lxClosingDates : product?.classification]"
></lx-quote-product-description>

<!-- Product Accordion All Prices Except Supplement ESL -->
<lx-quote-price-item
  [hasProductPrice]="!product?.priceOnRequest || isCourse"
  [productPrice]="product?.price | lxPrice : { currency: currency, minDecimalPlaces: decimalPlaces }"
></lx-quote-price-item>

<!-- Product Accordion Supplement ESL -->
<lx-quote-product-supplement [product]="product" [currency]="currency" [decimalPlaces]="decimalPlaces"></lx-quote-product-supplement>
